import { render } from "./profile.html?vue&type=template&id=36711998&ts=true"
import script from "./profile.ts?vue&type=script&lang=ts"
export * from "./profile.ts?vue&type=script&lang=ts"

import "./profile.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "C:\\Desarrollo\\Proyectos\\Codigo\\Helpharma\\Vigiflow\\automation-logs-adminlte-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__